import ChallengeTable from './ChallengeTable.vue';

// @ts-ignore
ChallengeTable.install = (Vue) => {
  Vue.component((ChallengeTable as any).options.name, ChallengeTable);
};

export default ChallengeTable;
